import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
} from 'antd';
import { ToolOutlined } from '@ant-design/icons';
import { onError, onSuccess } from 'utils/handlers';
import { patchUsuario } from 'api/usuarios/usuarios';
import { getCanalesDePago } from 'api/configuracion/canalDePago';
import { isMutable } from 'utils/estadosGlobales';
import ModalCanalDePago from './ModalCanalDePago';

export const model = 'canaldepago';
export const catalogsModels = ['usuario', 'catalogodecanalesdepago'];

const CanalesDePago = ({
  disabled,
}) => {
  const [form] = Form.useForm();
  const [formModal] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [selectedCanal, setSelectedCanal] = useState();
  const [usersFound, setUserFound] = useState({});
  const [mutable, setMutable] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const res = await getCanalesDePago();
    const filtered = res.data.filter((c) => c.id !== 2);
    setData(filtered);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetch = async () => {
      setLoading(true);
      const _data = await getCanalesDePago();
      if (mounted) {
        setData(_data);
        setLoading(false);
      }
    };
    fetch();
    return () => { mounted = false; };
  }, []);

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const keys = Object.keys(values);
      const results = [];
      const promises = [];

      keys.forEach((e) => {
        const id = parseInt(e, 10);
        results.push({
          id,
          users: values[e],
        });
      });

      if (results.length) {
        results.forEach((e) => {
          let promise;
          e.users.forEach((i) => {
            promise = patchUsuario(i, { canal_de_pago: e.id });
          });
          promises.push(promise);
        });
      }

      if (promises?.length) {
        const responses = await Promise.all(promises);
        onSuccess(responses, 'Actualizado Correctamente');
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickConfig = async (canal) => {
    setLoading(true);
    setSelectedCanal(canal);
    const _canales = await getCanalesDePago({ catalogo_de_canal_de_pago: canal.id });
    const dataLength = _canales?.length;
    const values = _canales.at(-1);
    setMutable(isMutable(values));
    formModal.setFieldsValue({
      ...values,
      usuario: _canales.at(-1)?.cajeros[0]?.id,
    });
    if (dataLength && _canales.at(-1)?.cajeros?.length) {
      setUserFound([_canales.at(-1)?.cajeros[0]]);
    } else {
      setUserFound([]);
    }
    setVisible(true);
    setLoading(false);
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Form
          layout="vertical"
          form={form}
          onFinish={() => onFinish()}
          scrollToFirstError
        >
          <br />
          <Row gutter={10}>
            {data.map((e) => (
              <Col xs={24} sm={24} md={12} key={e.id}>
                <Form.Item
                  label={`Canal de Pago ${e.descripcion}`}
                >
                  <Button disabled={disabled} onClick={() => onClickConfig(e)} block>
                    <ToolOutlined />
                    Configurar
                  </Button>
                </Form.Item>
              </Col>
            ))}
          </Row>
          <Form.Item hidden>
            <Button htmlType="submit" />
          </Form.Item>
        </Form>
        <ModalCanalDePago
          visible={visible}
          setVisible={setVisible}
          canal={selectedCanal}
          form={formModal}
          usersFound={usersFound}
          setUsersFound={setUserFound}
          mutable={mutable}
        />
      </Spin>
    </Row>
  );
};

CanalesDePago.propTypes = {
  disabled: PropTypes.bool.isRequired,
};

export default CanalesDePago;
